module.exports = new __parcel__URL__("DSCSA_Packing_Slip.b8795f59.jpg").toString();